<template>
  <footer>
    <span>
      <email-link v-if="data.email" :email="data.email"></email-link> Digital Iko Tema
    </span>
    <span>{{ data.location }}</span>
    <span>{{ data.cnpj }}</span>
    <div class="meta-info">
      <a v-if="data['website repository']" :href="data['website repository']" :title="$t('source code')" target="_blank"><svg-icon name="gitlab"/></a>
      {{ $t('made with') }}
      <a href="https://vuejs.org" target="_blank">VueJs</a>
      &
      <a href="https://feathericons.com" target="_blank">FeatherIcons</a>
    </div>
  </footer>
</template>

<script>
import data from '@/dataLoader'

export default {
  computed: {
    data () { return data.digital[this.$i18n.locale] }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/FooterBar.vue